module.exports = __webpack_public_path__ + "static/Slide03@1x.c08e7451.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Slide03@1x.png
// module id = 708
// module chunks = 216210090109534